import { HpPostScriptErrorFunction, postScriptError } from '../engineClient/tools/postScriptError';
import { HpFetchError } from '../engineClient/types';
import { HpErrorPageModel } from './errorPage';

export type ErrorPageTypes = 'retry' | 'call-us' | 'not-found' | 'other';

interface NhiQuoteErrorSummary {
  HeadingText: string;
  MessageText: string;
  PolicyReferenceText: string;
  QuoteStatus: number;
  ReferenceNumber: string;
  SubHeadingText: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function mapToErrorModel(
  errorDetails: unknown,
  errorPageType: ErrorPageTypes,
  postScriptErrorForTest?: HpPostScriptErrorFunction
): HpErrorPageModel {
  let showContinue = false;
  let notFound = false;
  const { messages } = (errorDetails as any) || {};
  let details = messages ? messages[0] : undefined;
  let quoteErrorSummary = {};
  if (typeof details === 'string') {
    if (details.startsWith('Details:')) {
      details = details.substring('Details:'.length);
      try {
        quoteErrorSummary = JSON.parse(details);
      } catch (error) {
        (postScriptErrorForTest || postScriptError)(
          {
            message: 'An error occurred while parsing the error detail.',
            exception: (error as any).message || error,
            errorDetails
          },
          'warn'
        );
      }
    }
  }

  let {
    HeadingText: heading,
    SubHeadingText: subHeading,
    MessageText: paragraph1,
    PolicyReferenceText: paragraph2
  } = (quoteErrorSummary as NhiQuoteErrorSummary) || {};
  if (errorPageType === 'call-us') {
    heading = 'Sorry, we have experienced a problem';
    paragraph1 = '<strong>A technical issue is preventing us from continuing.</strong>';
    paragraph2 = 'Please call <strong>0330 660 1000</strong> to continue logging this incident with our claims team.';
  } else if (!heading) {
    heading = 'Oops';
    subHeading = "We're having a few problems processing your details.";
    paragraph1 =
      'Click below to try again. If this problem continues, you can always call our claims team on <strong>0330 660 1000</strong>';
    paragraph2 = '';
    showContinue = true;
    if (errorPageType === 'not-found') {
      subHeading = "Sorry, that page doesn't exist";
      paragraph1 = '';
      notFound = true;
    }
  }

  return { heading, subHeading, paragraph1, paragraph2, showContinue, notFound };
}

export function getErrorPageType(
  fetchError: HpFetchError | undefined,
  showErrorPageAfterConsecutiveErrorCount: number
): ErrorPageTypes {
  const { count } = fetchError || {};
  let errorPage: ErrorPageTypes = 'other';
  if (!fetchError) {
    errorPage = 'not-found';
  } else if (!count || count < showErrorPageAfterConsecutiveErrorCount) {
    errorPage = 'retry';
  } else if (count && count >= showErrorPageAfterConsecutiveErrorCount) {
    errorPage = 'call-us';
  }

  return errorPage;
}
